import { RouteConfig } from 'vue-router';

import ResetPasswordForm from '@/components/material/ResetPasswordForm.vue';
import ResetPassword from '@/components/material/ResetPassword.vue';
import ResetPasswordRoute from '@/components/material/ResetPasswordRoute.vue';

export const resetFormRoute: RouteConfig = {
  path: '/reset-password',
  component: ResetPasswordRoute,
  children: [
    {
      path: ':token',
      name: 'resetPassword',
      component: ResetPasswordForm
    },
    {
      path: '',
      name: 'resetPasswordEmail',
      component: ResetPassword
    }
  ]
};
